module.exports = __webpack_public_path__ + "static/media/Viper_(Full).e0a9d632.png";